import { render, staticRenderFns } from "./SubmitMusic.vue?vue&type=template&id=ac26ebc8"
import script from "./SubmitMusic.vue?vue&type=script&lang=js"
export * from "./SubmitMusic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports